import { Injectable } from '@angular/core'
import { MbJobTitlesAdapter } from './mb-job-titles.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbJobTitlesConnector {

  constructor (protected adapter: MbJobTitlesAdapter) {
  }

  get () {
    return this.adapter.load()
  }
}
